import React from 'react';
import {
  SalvDropdown,
  SalvRadioToggleButton,
  SalvRadioToggleGroup,
  SalvSearchField,
  Size,
} from '@salvapp/ui-components';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { useSearchParams } from 'react-router-dom';

export enum ScenarioEntityFilterType {
  ALL = 'ALL',
  TRANSACTION = 'TRANSACTION',
  PERSON = 'PERSON',
}

export interface ScenarioFiltersState {
  entity: ScenarioEntityFilterType;
  type: DropdownOption[];
  status: DropdownOption[];
  query?: string;
  categories: DropdownOption[];
}

const ScenarioFilters = ({
  filters,
  onFiltersUpdate,
  options,
  selectedTab,
}: {
  filters: ScenarioFiltersState;
  onFiltersUpdate: (filters: ScenarioFiltersState) => void;
  options: { [key: string]: DropdownOption[] };
  selectedTab: string;
}) => {
  const { statusOptions, typeOptions, categoryOptions } = options;

  const [searchParams, setSearchParams] = useSearchParams();

  const dropdownProps = {
    className: 'm-l-16',
    isMulti: true,
  };

  const setFilterParam = (name: string, value: any) => {
    if (Array.isArray(value)) {
      searchParams.set(name, value.map((v) => v.value).join('&'));
    } else {
      searchParams.set(name, value);
    }
    setSearchParams(searchParams);
  };

  return (
    <div>
      <div className='d-flex m-b-16'>
        <SalvRadioToggleGroup
          value={filters.entity}
          label='Alerting entity'
          onChange={(entity) => {
            onFiltersUpdate({
              ...filters,
              entity: ScenarioEntityFilterType[entity as keyof typeof ScenarioEntityFilterType],
            });

            setFilterParam('entity', entity);
          }}
        >
          <SalvRadioToggleButton label='All' value='ALL' />
          <SalvRadioToggleButton label='Transaction' value='TRANSACTION' />
          <SalvRadioToggleButton label='Person' value='PERSON' />
        </SalvRadioToggleGroup>

        <SalvDropdown
          {...dropdownProps}
          options={typeOptions}
          size={Size.SMALL}
          onChange={(type) => {
            onFiltersUpdate({
              ...filters,
              type,
            });

            setFilterParam('type', type);
          }}
          placeholder='All'
          value={filters.type}
          label='Type'
        />

        {selectedTab !== 'library' && (
          <SalvDropdown
            {...dropdownProps}
            options={statusOptions}
            size={Size.SMALL}
            onChange={(status) => {
              onFiltersUpdate({
                ...filters,
                status,
              });

              setFilterParam('status', status);
            }}
            placeholder='All'
            value={filters.status}
            label='Status'
          />
        )}

        <SalvDropdown
          {...dropdownProps}
          options={categoryOptions}
          size={Size.SMALL}
          onChange={(categories) => {
            onFiltersUpdate({
              ...filters,
              categories,
            });

            setFilterParam('categories', categories);
          }}
          placeholder='All'
          value={filters.categories}
          label='Category'
        />
      </div>

      <SalvSearchField
        ariaLabel='Search scenarios'
        size={Size.SMALL}
        placeholder='Search ID, name'
        onChange={(query) => {
          onFiltersUpdate({
            ...filters,
            query,
          });
        }}
        onSubmit={(query) => {
          onFiltersUpdate({
            ...filters,
            query,
          });
        }}
        value={filters.query}
      />
    </div>
  );
};

export default ScenarioFilters;
